import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiZap,FiEye,FiUsers,FiTrendingUp,FiShield}=FiIcons;

const SolutionSection=()=> {
  const features=[
    {icon: FiEye,title: "รู้เขารู้เรา",description: "เข้าใจว่าทำไมหัวหน้าคนนี้ถึงชอบคนพูดตรง? ทำไมลูกน้องคนนี้ต้องใช้วิธีพูดอ้อมๆ?",subtitle: "(Management Psychology)"},
    {icon: FiUsers,title: "Team Synergy",description: "วางคนให้ถูกธาตุ เอาคนธาตุไฟไปกระตุ้นคนธาตุดิน เอาคนธาตุทองไปตัดแต่งคนธาตุไม้... ทีมเวิร์กจะลื่นไหลจนน่าตกใจ",subtitle: ""},
    {icon: FiShield,title: "Compatibility",description: "สแกนคู่รักหรือหุ้นส่วน... ว่าดวงนี้มาเพื่อ \"ส่งเสริม (Support)\" หรือมาเพื่อ \"ทำลาย (Destroy)\"",subtitle: ""}
  ];

  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-900/10 to-transparent"></div>
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            <span className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              MBTI on Steroids
            </span>
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-8">
            ขอต้อนรับสู่ <span className="text-green-400">"เครื่องสแกนมนุษย์"</span> ที่แม่นยำที่สุด
          </h3>
          <div className="bg-slate-800/40 backdrop-blur-sm border border-green-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h4 className="text-2xl md:text-3xl font-bold text-white mb-6">
              Bazi Love & Relationships <span className="text-green-400">(2 Days Workshop)</span>
            </h4>
            <div className="grid md:grid-cols-2 gap-8 text-left">
              <div>
                <p className="text-lg text-gray-300 mb-4">
                  ถ้า <span className="text-blue-400 font-semibold">MBTI</span> บอกได้ว่า เขา <span className="text-yellow-400">"ชอบ"</span> คิดแบบไหน...
                </p>
                <p className="text-lg text-green-400 font-semibold">
                  Bazi (ปาจื้อ) จะบอกได้เลยว่า เขา <span className="text-white">"จะทำ"</span> อะไรกับคุณ !
                </p>
              </div>
              <div>
                <p className="text-lg text-gray-300">
                  นี่คือวิชาที่ไม่ได้สอนให้คุณจับผิด... แต่สอนให้คุณ <span className="text-pink-400 font-semibold"> "บริหารความสัมพันธ์"</span> อย่างเหนือชั้น
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature,index)=> (
            <motion.div
              key={index}
              initial={{y: 50,opacity: 0}}
              whileInView={{y: 0,opacity: 1}}
              transition={{duration: 0.8,delay: index * 0.2}}
              viewport={{once: true}}
              className="group"
            >
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 h-full hover:border-green-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-green-500/10">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <SafeIcon icon={feature.icon} className="text-2xl text-white" />
                </div>
                <h4 className="text-xl font-bold text-white mb-2">
                  ● {feature.title}:
                </h4>
                {feature.subtitle && (
                  <p className="text-green-400 text-sm font-medium mb-3">
                    {feature.subtitle}
                  </p>
                )}
                <p className="text-gray-300 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.8}}
          viewport={{once: true}}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-sm border border-green-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h4 className="text-2xl md:text-3xl font-bold text-white mb-4">
              อ่านคนขาดทะลุถึงกระดูก... แม่นยำกว่า MBTI ลึกซึ้งกว่าจิตวิทยา และโกหกกันไม่ได้!
            </h4>
            <button className="group relative px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-bold text-lg rounded-full shadow-2xl hover:shadow-green-500/25 transition-all duration-300 transform hover:scale-105 border border-green-400/50 mt-6">
              <span className="flex items-center space-x-2">
                <SafeIcon icon={FiZap} className="text-xl" />
                <span>จองที่นั่งทันที! (รู้คนให้ขาด ก่อนจะพลาดท่า)</span>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
            </button>
            <p className="text-green-300 mt-4 font-medium">
              รุ่นพิเศษ: 21-22 ก.พ. 2569
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionSection;